import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CbFormsModule } from '@app/shared/components/forms/forms.module';
import { CbHubTableModule } from '@app/shared/components/table/table.module';
import { CbModelDebounceModule } from '@app/shared/directives/model-debounce/model-debounce.module';
import { CbWaitForModule } from '@app/shared/directives/wait-for/wait-for.module';
import {
    CompleteMultipleActivitiesDialogComponent
} from '@app/views/teams/all-teams/incomplete-build-activities/complete-multiple-activities-dialog/complete-multiple-activities-dialog.component';
import { CbDasherModule, CbLoadingSpinnerModule, CbSelectListModule, CbTableModule } from 'cb-hub-lib';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { IncompleteBuildActivitiesComponent } from './incomplete-build-activities.component';
import {CbDialogModule} from '@app/shared/components/dialog/dialog.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {CbClickModule} from '@app/shared/directives/click/click.module';

@NgModule({
    declarations: [
        IncompleteBuildActivitiesComponent,
        CompleteMultipleActivitiesDialogComponent
    ],
    imports: [
        CbFormsModule,
        CbLoadingSpinnerModule,
        CbSelectListModule,
        CommonModule,
        FormsModule,
        InfiniteScrollDirective,
        MatButtonModule,
        MatCardModule,
        MatCardModule,
        MatCheckboxModule,
        MatIconModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        MatTableModule,
        ReactiveFormsModule,
        CbDasherModule,
        CbHubTableModule,
        CbTableModule,
        MatMenuModule,
        CbModelDebounceModule,
        CbWaitForModule,
        MatTooltipModule,
        CbDialogModule,
        MatProgressSpinnerModule,
        CbClickModule
    ],
    exports: [
        IncompleteBuildActivitiesComponent,
        CompleteMultipleActivitiesDialogComponent
    ]
})
export class IncompleteBuildActivitiesModule { }
